import { Button, IconButton, Tooltip } from '@sweep-io/sweep-design';
import { Sparkle } from '@sweep-io/sweep-design/dist/icons';
import { BiEvent } from '../../services/events';
import useSendBiEvent from '../../hooks/useSendBiEvent';
import { useCallback } from 'react';
import useIsAnyAgentEnabled from './useIsAnyAgentEnabled';
import useAgentsHome from './useAgentsHome';
import usePaywall from '../dashboard/paywall/usePaywall';

const AgentsHomeButton = ({
  onClick,
  variant,
  disabled,
  asIcon,
  biEvent,
}: {
  onClick: () => void;
  variant: 'primary' | 'system';
  disabled?: boolean;
  asIcon?: boolean;
  biEvent?: BiEvent;
}) => {
  const isAiAgentsEnabled = useIsAnyAgentEnabled();
  const { isOpened } = useAgentsHome();
  const sendBiEvent = useSendBiEvent();
  const { isPaywallActive } = usePaywall();

  const onClickAndSendBiEvent = useCallback(() => {
    onClick();
    if (biEvent) {
      sendBiEvent(biEvent);
    }
  }, [biEvent, onClick, sendBiEvent]);

  if (isPaywallActive || !isAiAgentsEnabled) {
    return null;
  }

  return asIcon ? (
    <Tooltip title="Agentic" placement="bottom">
      <span>
        <IconButton
          onClick={onClickAndSendBiEvent}
          variant={variant}
          size="small"
          disabled={disabled}
          pressed={isOpened}
        >
          <Sparkle />
        </IconButton>
      </span>
    </Tooltip>
  ) : (
    <Button
      onClick={onClickAndSendBiEvent}
      variant={variant}
      size="small"
      startIconName="Sparkle"
      disabled={disabled}
      pressed={isOpened}
    >
      Agentic
    </Button>
  );
};

export default AgentsHomeButton;
